import ModalsInfoLib from '../../lib/modals-info';

export default () => {
    return (
        <div className="modal-info-container">
            <div className="modal-info animate__animated animate__fadeInUp animate__faster">
                <div className="close-button" onClick={e => ModalsInfoLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div className="modal-info-content">
                    <div className="modal-info-image">
                        <img src={`${window.location.origin}/source/system/modal-info/vip20-info.png`} alt="" />
                    </div>

                    <div className="modal-info-body">
                        <div className="modal-info-body-content">
                            <p> 
                                <h1>VIP 2.0 System</h1>

                                <span>VIP status is based on your activity over the last <b>365 days</b>.</span>
                                <span>Your VIP level is calculated based on your total deposits during this period.</span>
                            </p>

                            <p>
                                <h2>How is VIP calculated?</h2>
                                <span>Your final VIP XP is calculated using the following formula:</span>
                                <span><b>VIP XP = (Base Activity × Crypto Multiplier)</b></span>
                            </p>

                            <p>
                                <h2>What is Base Activity?</h2>
                                <span>Base Activity reflects the total amount of your deposits made over the last <b>365 days</b>.</span>
                                <span><b>Base Activity = Total Deposits over the last 365 days</b></span>
                            </p>

                            <p>
                                <h2>What is Crypto Multiplier?</h2>
                                <span>Crypto Multiplier rewards players who use crypto deposits.</span>
                                <span>It is based on the share of your crypto deposits over the last <b>365 days</b>:</span>
                                <span>
                                    30% – 59% → <b>×1.1</b> (+10%)<br/>
                                    60% – 89% → <b>×1.2</b> (+20%)<br/>
                                    90%+ → <b>×1.3</b> (+30%)<br/>
                                    <br/>
                                    (If crypto usage is below 30%, no bonus is applied.)
                                </span>
                            </p>

                            {/* <p>
                                <h2>What is Loss Shield?</h2>
                                <span>Loss Shield provides additional XP based on your net losses.</span>
                                <span>Unlike other components, Loss Shield is calculated based on your <b>overall activity</b> and is not limited to the 30-day window.</span>
                                <span>This bonus is added on top of your activity and is not affected by the Crypto Multiplier.</span>
                            </p> */}

                            <p>
                                <h2>VIP Levels</h2>
                                <span>
                                    Regular — <b>0–499 XP</b><br/>
                                    Bronze — <b>500–1499 XP</b><br/>
                                    Silver — <b>1500–4999 XP</b><br/>
                                    Gold — <b>5000–8999 XP</b><br/>
                                    Platinum — <b>9000–12499 XP</b><br/>
                                    Diamond — <b>12500–15499 XP</b><br/>
                                    Elite — <b>15500+ XP</b><br/>
                                </span>
                            </p>

                            <p>
                                <h2>Important Note</h2>
                                <span>All bonuses and rewards are based on your <b>current VIP level</b> at the moment they are granted.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-info-overlay animate__animated animate__fadeIn animate__faster"></div>
        </div>
    )
}